import CrudIndex from "./js/CrudIndex.jsx";
import CrudForm from "./js/CrudForm.jsx";

export {
    CrudIndex, CrudForm
};

export default function ()
{
    console.log('Crud ready!');
}